import React, { Component } from 'react';
import {
    Tabs, Tab, Divider, IconButton, Tooltip, Box, Typography
} from "@mui/material";
import '../../../Components/Common Components/CommonTabs';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { clearCachevalue, getCachevalue } from '../../../Utility/Services/CacheProviderService';
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions';
import { filterMenuBySubscription } from '../../../Utility/AccessUtils';
import { ImagePaths } from '../../../Utility/ImagePaths';
import { PermissionsContext } from '../../../Utility/PermissionContext';


const sub_menu_access = [
    {
        "sub_menu": 'Laboratory Billing',
        "access_granted": true,
        "full_access": true,
        "access_type": "r-w-u-d",
    },
    {
        "sub_menu": 'Radiology Billing',
        "access_granted": true,
        "full_access": true,
        "access_type": "r-w-u-d",
    }]

export default class BillingHome extends Component {
    static contextType = PermissionsContext;
    
    constructor(props, context) {
        super(props, context);
        // Get subscriptionData and role from context or props
        const { subscriptionData, role } = context || {};
        const finalSubscriptionData = props.subscriptionData || subscriptionData;
        const finalRole = props.role || role;
        
        // Filter the list by subscription, same as CommonTabs
        const filteredList = filterMenuBySubscription(props.List, finalSubscriptionData, finalRole) || [];
        const findSelectionFromFiltered = (selTab) => {
            if (!selTab) return null;
            // check main tabs
            let item = filteredList.find(it => it.id === selTab.id);
            if (item) {
                // if selTab refers to a main tab
                const sub = item.subMenu && item.subMenu.length ? item.subMenu[0] : null;
                return { item, sub };
            }
            // search submenus
            for (let it of filteredList) {
                const sub = (it.subMenu || []).find(sm => sm.id === selTab.id);
                if (sub) return { item: it, sub };
            }
            return null;
        };

        const initialSelection = findSelectionFromFiltered(props.selectedTab)
            || (filteredList[0] ? { item: filteredList[0], sub: (filteredList[0].subMenu && filteredList[0].subMenu[0]) || null } : { item: null, sub: null });

        this.state = {
            MainTabIndex: initialSelection.item ? initialSelection.item?.id : (props.selectedTab ? props.selectedTab?.id : (filteredList[0]?.id || null)),
            SubTabIndex: initialSelection.sub ? initialSelection.sub.id : (props.selectedTab ? (props.selectedTab?.subMenu.length > 0 ? props.selectedTab?.subMenu[0]?.id : 0) : 0),
            List: filteredList,
            SelectedItem: initialSelection.item || props.selectedTab || filteredList[0] || null,
            SelectedSubItem: initialSelection.sub || (props.selectedTab ? (props.selectedTab?.subMenu.length > 0 ? props.selectedTab?.subMenu[0] : null) : null),
            BackScreen: props.BackToHome ? props.BackToHome : null,
            isSubRendered: false
        }
    }
    componentWillReceiveProps(props) {
        // Get subscriptionData and role from context or props
        const { subscriptionData, role } = this.context || {};
        const finalSubscriptionData = props.subscriptionData || subscriptionData;
        const finalRole = props.role || role;
        
        // Filter the list by subscription when props change
        const filteredList = filterMenuBySubscription(props.List, finalSubscriptionData, finalRole) || [];
        const findSelectionFromFiltered = (selTab) => {
            if (!selTab) return null;
            let item = filteredList.find(it => it.id === selTab.id);
            if (item) {
                const sub = item.subMenu && item.subMenu.length ? item.subMenu[0] : null;
                return { item, sub };
            }
            for (let it of filteredList) {
                const sub = (it.subMenu || []).find(sm => sm.id === selTab.id);
                if (sub) return { item: it, sub };
            }
            return null;
        };

        const initialSelection = findSelectionFromFiltered(props.selectedTab)
            || (filteredList[0] ? { item: filteredList[0], sub: (filteredList[0].subMenu && filteredList[0].subMenu[0]) || null } : { item: null, sub: null });

        this.setState({
            List: filteredList,
            SelectedItem: initialSelection.item || props.selectedTab || filteredList[0] || null,
            MainTabIndex: initialSelection.item ? initialSelection.item?.id : (props.selectedTab ? props.selectedTab?.id : (filteredList[0]?.id || null)),
            BackScreen: props.BackToHome ? props.BackToHome : null,
            SubTabIndex: initialSelection.sub ? initialSelection.sub.id : (props.selectedTab ? (props.selectedTab?.subMenu.length !== 0 ? props.selectedTab?.subMenu[0]?.id : 0) : 0),
            SelectedSubItem: initialSelection.sub || (props.selectedTab ? (props.selectedTab?.subMenu.length > 0 ? props.selectedTab?.subMenu[0] : null) : null)
        })
    }
    handleChange = (event, newValue) => {
        this.setState({
            MainTabIndex: newValue,
            SelectedItem: this.state.List.filter((item) => item.id == newValue)[0]
        }, () => {
            let { history } = this.props
            history.push({ pathname: `${this.state.SelectedItem.path}` })
        })

    };
    handleChangesub = (event, newValue) => {
        this.setState({
            SubTabIndex: newValue,
            SelectedSubItem: this.state.SelectedItem.subMenu.filter((item) => item.id == newValue)[0]
        })
    };

    checkAccess = (data) => {
        try {
            let patientDatas = getCachevalue("patientData")
            let patients = JSON.parse(patientDatas)
            if (data.menuName === "Nurse Notes" || data.menuName === "Billing") {
                if (patients?.appointment_id) { return true } else { return false }
            }
            else {
                return true
            }
        }
        catch (e) {
            console.log(e?.message)
            return true
        }
    }

    SubTabcheckAccess = (data) => {
        try {
            if (data.Access?.viewAccess === false) {
                return false
            }
            else {
                return true
            }
        }
        catch (e) {
            return true
        }
    }
    
    renderMainComponent = (data, Type) =>{
        // Get role from context or props
        const { role: contextRole } = this.context || {};
        const role = this.props.role || contextRole;
        const { showLockPopup } = this.props;

        if (!data) {
            // nothing selected or filtered out — show friendly message or null
            return <Typography className='eMed_NoAccess_Text' sx={{paddingTop: Type === "Tab" ? "15.65vw": "13vw"}}>No Screen Selected</Typography>;
        }

        const isLocked = !!data.is_locked; // always defined after filtering

        if (role === "admin" && isLocked) {
            // Admin sees the locked tab but we trigger popup instead of the component
            if (typeof showLockPopup === 'function') showLockPopup(data.menuName);
            return <Box className="eMed_NoAccess_Text" sx={{ paddingTop: '5vw', marginLeft: "-40vw", textAlign: 'center' }}>
                <img src={ImagePaths.LockScreen.default} alt="Lock" />
                <Typography sx={{ marginTop: '1vw', fontSize: '1.2vw', fontWeight: 600 }}>This feature is locked.</Typography>
            </Box>;
        }

        if (role === "user" && isLocked) {
            // User should not reach here normally because filter removes locked items,
            // but guard anyway
            return <Typography className='eMed_NoAccess_Text' sx={{paddingTop: Type === "Tab" ? "15.65vw": "13vw"}}>No Access For This Screen</Typography>;
        }

        // Check viewAccess for backward compatibility
        if(data.Access?.viewAccess === true){
            return data?.component
        }
        else if (data.Access?.viewAccess === false){
            return <Typography className='eMed_NoAccess_Text' sx={{paddingTop: Type === "Tab" ? "15.65vw": "13vw"}}>No Access For This Screen</Typography>
        }else{
            return data?.component
        }
    }

    render() {
        let { history } = this.props
        return (
            <div>
                <div className='eMed_tabWrapper'>
                    {
                        this.state.BackScreen === null ? null :
                            <div>
                                <Tooltip title="Back" placement='top' arrow>
                                    <IconButton onClick={() => {
                                        history.push({ pathname: `${this.state.BackScreen}` })
                                        if(this.state.BackScreen !== "/IPHome/Demographics/AdmissionHistory"){
                                            clearCachevalue("patientData");
                                            clearCachevalue("IppatientData");
                                            clearCachevalue("OP_CreateAppointment_PatientId");
                                            clearCachevalue("AppRequestPatientData");
                                        }
                                        clearCachevalue("withoutAppointment");
                                    }}>
                                        <ChevronLeftIcon color='primary' />
                                    </IconButton>
                                </Tooltip>
                            </div>
                    }
                    <div >
                        <Box sx={{ width: '100%' }}>
                            <Box >
                                <Tabs
                                    value={this.state.MainTabIndex}
                                    onChange={this.handleChange}
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    sx={{ minHeight: '1vw', width: '100%' }}
                                >
                                    {this.state.List && this.state.List.length > 0 && this.state.List.map((data, index) => {
                                        if(this.checkAccess(data)){
                                            return (
                                                <Tab
                                                    sx={{ textTransform: 'capitalize', minHeight: '1vw', fontWeight: 600 }}
                                                    disabled={!(sub_menu_access.filter((item) => item.sub_menu == data.menuName).length > 0 ? sub_menu_access.filter((item) => item.sub_menu == data.menuName)[0].access_granted : true) ||  (getCachevalue("isInRadiologyBilling") === "true")}
                                                    key={data.id}
                                                    value={data.id}
                                                    label={data.menuName} 
                                                    />
                                            )}
                                    }
                                    )}
                                </Tabs>
                            </Box>
                        </Box>
                    </div>
                </div>

                <div>
                    {
                        Object.keys(this.state.SelectedItem).length !== 0 ?
                            this.state.SelectedItem.subMenu?.length === 0 ?
                                <div className='eMed_MainComponentDiv'>
                                    {this.renderMainComponent(this.state.SelectedItem, "Tab")}
                                </div>
                                :
                                <div>
                                    {
                                        this.state.SubTabIndex != 0 ?
                                            <div>
                                                <Tabs
                                                    value={this.state.SubTabIndex}
                                                    onChange={this.handleChangesub}
                                                    variant="scrollable"
                                                    scrollButtons="auto"
                                                    sx={{ minHeight: '1vw' }}
                                                >
                                                    {
                                                        this.state.SelectedItem.subMenu.map((data, index) => {
                                                                return (
                                                                    <Tab  sx={{ textTransform: 'capitalize', minHeight: '1vw', fontWeight: 600 }} key={data.id} value={data.id} label={data.menuName} />
                                                                )

                                                        })
                                                    }
                                                </Tabs>
                                                <div className='eMed_SubComponentDiv'>
                                                {this.renderMainComponent(this.state.SelectedSubItem, "SubTab")}
                                                </div>
                                            </div> : null
                                    }
                                </div>
                            : null
                    }
                </div>
            </div>
        )
    }
}
